import React from "react";
import VehicleInfo, { VehicleInfoSkeleton } from "./VehicleInfo/VehicleInfo";
import VehicleContent, { VehicleContentSkeleton } from "./VehicleContent/VehicleContent";

export default function StockListViewContainer({ data }) {
  return (
    <div className="row">
      <div className="col-12 col-md-4">
        <VehicleInfo data={data} />
      </div>
      <div className="col-12 col-md-8">
        <VehicleContent data={data} />
      </div>
    </div>
  );
}

// skeleton
export function StockListViewContainerSkeleton() {
  return (
    <div className="row">
      <div className="col-12 col-md-4">
        <VehicleInfoSkeleton />
      </div>
      <div className="col-12 col-md-8">
        <VehicleContentSkeleton />
      </div>
    </div>
  );
}
